import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { PlusPromo } from "../../../../components/PlusPromo";
import { cn } from "../../../../utils/cn";

interface PremiumBannerProps {
  visible: boolean;
  draftAvailable: boolean;
}

/** PLUS highlight above the Keepos list, with the same look as the other PLUS blocks. */
export const PremiumBanner = ({ visible, draftAvailable }: PremiumBannerProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div
      className={cn("float-banner", {
        visible: visible,
        "draft-available": draftAvailable,
      })}>
      {/* Wrapped so the global `.float-banner > button` styles don't reach the promo's button */}
      <div className="w-full" hidden={!visible}>
        <PlusPromo
          compact
          title={t("components.bannerPremium.title")}
          description={t("components.bannerPremium.description")}
          onClick={() => navigate("/subscription/features")}
        />
      </div>
    </div>
  );
};
